export default __webpack_public_path__ + "static/media/hospitality-mobile.f9da371b.jpg";